import moment from "moment";

/**
 * Standardized Indian Rupee & Number Formatters across TRDR Dashboard
 */

export function formatINR(amt, decimals = 2) {
  if (amt === null || amt === undefined || isNaN(amt)) return "₹0.00";
  const num = Number(amt);
  return `₹${num.toLocaleString("en-IN", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}`;
}

export function formatMoneyWithSign(amt, decimals = 2) {
  if (amt === null || amt === undefined || isNaN(amt)) return "₹0.00";
  const num = Number(amt);
  const sign = num > 0 ? "+" : "";
  return `${sign}₹${num.toLocaleString("en-IN", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}`;
}

export function formatCapital(amt) {
  if (amt === null || amt === undefined || isNaN(amt) || Number(amt) <= 0) return "₹0.00";
  const num = Number(amt);
  if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
  if (num >= 100000) return `₹${(num / 100000).toFixed(2)} L`;
  return `₹${num.toLocaleString("en-IN")}`;
}

export function formatPrice(price) {
  if (price === null || price === undefined || isNaN(price)) return "₹0.00";
  return `₹${Number(price).toFixed(2)}`;
}

export function formatSizingMode(mode, allocPct, mult, fixedLot) {
  if (mode === "CUSTOM_MULTIPLIER" || mode === "FIXED_MULTIPLIER") {
    return `${(mult || 1.0).toFixed(1)}x Multiplier`;
  }
  if (mode === "FIXED_LOT") {
    return `Fixed (${fixedLot || 25} qty)`;
  }
  if (mode === "HYBRID_CAPPED") {
    return `Hybrid (${allocPct || 20}%, Cap ${fixedLot || 100})`;
  }
  return `Cash Dynamic (${allocPct || 20}%)`;
}

export function getSizingBadgeColor(mode) {
  if (mode === "FIXED_LOT") return "color-gray";
  if (mode === "CUSTOM_MULTIPLIER" || mode === "FIXED_MULTIPLIER") return "color-purple";
  if (mode === "HYBRID_CAPPED") return "color-teal";
  return "color-blue";
}

export function formatTime(ts, format = "HH:mm:ss") {
  if (!ts) return "-";
  return moment(ts).format(format);
}

export function formatDateTime(ts, format = "DD/MM/YYYY HH:mm:ss") {
  if (!ts) return "-";
  return moment(ts).format(format);
}

export function formatDate(ts, format = "DD/MM/YYYY") {
  if (!ts) return "-";
  return moment(ts).format(format);
}

export function formatNumber(val, decimals = 2) {
  if (val === null || val === undefined || isNaN(val)) return "0";
  const num = Number(val);
  return num.toLocaleString("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  });
}

export function formatPercent(val, decimals = 2) {
  if (val === null || val === undefined || isNaN(val)) return "0%";
  const num = Number(val);
  return `${num.toFixed(decimals)}%`;
}

export function isTierUnassigned(tier) {
  return !tier || String(tier).trim().toUpperCase() === "NULL" || String(tier).trim().toUpperCase() === "UNASSIGNED";
}

export function formatTierBadge(tier, customLot = null) {
  if (isTierUnassigned(tier)) {
    return {
      label: "⚠️ UNASSIGNED",
      colorClass: "tier-unassigned",
      bg: "#ef4444",
      text: "#ffffff",
      isUnassigned: true,
    };
  }
  const t = String(tier).trim().toUpperCase();
  if (t === "H") {
    return {
      label: "🔴 Tier H",
      colorClass: "tier-h",
      bg: "#fee2e2",
      text: "#b91c1c",
      isUnassigned: false,
    };
  }
  if (t === "M") {
    return {
      label: "🟡 Tier M",
      colorClass: "tier-m",
      bg: "#fef3c7",
      text: "#b45309",
      isUnassigned: false,
    };
  }
  if (t === "L") {
    return {
      label: "🟢 Tier L",
      colorClass: "tier-l",
      bg: "#dcfce7",
      text: "#15803d",
      isUnassigned: false,
    };
  }
  if (t === "CUSTOM") {
    const lotStr = customLot ? ` (${customLot}sh)` : "";
    return {
      label: `⚪ Custom${lotStr}`,
      colorClass: "tier-custom",
      bg: "#e0e7ff",
      text: "#4338ca",
      isUnassigned: false,
    };
  }
  return {
    label: t,
    colorClass: "tier-other",
    bg: "#e2e8f0",
    text: "#334155",
    isUnassigned: false,
  };
}
